import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=4880d778&scoped=true"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"
import style0 from "./TagList.vue?vue&type=style&index=0&id=4880d778&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4880d778",
  null
  
)

export default component.exports